import { render } from "./ProposalEditor.vue?vue&type=template&id=91079ef6&scoped=true&ts=true"
import script from "./ProposalEditor.vue?vue&type=script&lang=ts"
export * from "./ProposalEditor.vue?vue&type=script&lang=ts"

import "./ProposalEditor.vue?vue&type=style&index=0&id=91079ef6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91079ef6"]])

export default __exports__